import React from 'react'
import { Button } from 'antd'
import styles from './IntegrationActions.module.scss'

interface IIntegrationAction {
  label: string
  url: string
  icon?: React.ReactNode
  disabled?: boolean
}

interface IIntegrationActionsProps {
  actions: IIntegrationAction[]
  className?: string
}

export const IntegrationActions: React.FC<IIntegrationActionsProps> = ({
  actions,
  className
}) => {
  return (
    <div className={`${styles.root} ${className ?? ''}`}>
      {actions.map((action) => (
        <Button
          key={action.label}
          type='primary'
          icon={action.icon}
          href={action.url || undefined}
          target={action.url ? '_blank' : undefined}
          rel={action.url ? 'noreferrer' : undefined}
          disabled={action.disabled || !action.url}
          className={styles.button}
        >
          {action.label}
        </Button>
      ))}
    </div>
  )
}
